import React from 'react';
import { Link } from 'react-router-dom';

export default function GetStarted() {
    return (
        <>
        <div className='get-start-main-con'>
           <div className="px-3 px-md-5 row g-0">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-sm-none">
                    <div className='bg-grad-purple text-center get-start-img'>
                        <img src='/images/home/getstarted.jpg' alt="get-started-lurantech" />
                    </div>
                </div>
                <div  className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div className='get-start-container'>
                        <div className='head-text black'>Agile</div>
                        <div className='head-text grad-purple'>Innovation</div>
                        <div className='head-text black'>Quality</div>
                        <Link to="/contact-us"><div className='bg-btn-get-started'>Let's talk</div></Link>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-none d-sm-block">
                    <div className='bg-grad-purple text-center get-start-img'>
                        <img src='/images/home/getstarted.jpg' alt="get-started-lurantech" />
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
